import React, {
    useCallback,
    useContext,
    useState
} from "react";
import axios from "axios";
import {
    Alert,
    Button,
    Modal,
    Spinner
} from "react-bootstrap";
import PropTypes from "prop-types";

import ShopsContext from "../../../../context/ShopsContext";

function EditSegmentModal({ show, handleClose, product, segment, onSaved }) {
    const shopsContext = useContext(ShopsContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [price, setPrice] = useState("");

    const onShow = useCallback(() => {
        setLoading(false);
        setError(null);
        setPrice(segment ? String(segment.price) : "");
    }, [segment]);

    const handleSave = useCallback(async () => {
        if(!segment) return;
        if(!price || parseFloat(price) < 0) {
            setError("Prijs mag niet negatief zijn.");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post("/updateRentalProductSegment", {
                shopId: shopsContext.currentShop.id,
                productId: product.id,
                segmentId: segment.id,
                price: parseFloat(price),
            });
            if(response.data.valid) {
                handleClose();
                onSaved?.();
            } else {
                setError("Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")");
            }
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        }
        setLoading(false);
    }, [shopsContext.currentShop.id, product, segment, price, handleClose, onSaved]);

    return (
        <Modal show={ show } onHide={ handleClose } onShow={ onShow }>
            <Modal.Header closeButton>
                <Modal.Title>Segment bewerken</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { error && (
                    <Alert variant="danger">{ error }</Alert>
                )}
                <div className="form-group">
                    <label htmlFor="editSegmentStartTime">Starttijd</label>
                    <input
                        type="text"
                        className="form-control"
                        id="editSegmentStartTime"
                        value={ segment ? segment.startTime.substring(0, 5) : "" }
                        disabled
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="editSegmentDuration">Duur (minuten)</label>
                    <input
                        type="number"
                        className="form-control"
                        id="editSegmentDuration"
                        value={ segment ? segment.durationInMinutes : "" }
                        disabled
                    />
                </div>
                <div className="form-group mb-0">
                    <label htmlFor="editSegmentPrice">Prijs (Euro &euro;)</label>
                    <input
                        type="number"
                        className="form-control"
                        id="editSegmentPrice"
                        value={ price }
                        onChange={ (event) => setPrice(event.target.value) }
                        disabled={ loading }
                        min="0"
                        step="0.01"
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleClose } disabled={ loading }>
                    Annuleren
                </Button>
                <Button variant="primary" onClick={ handleSave } disabled={ loading }>
                    { loading && (
                        <Spinner animation="border" variant="light" size="sm" className="mr-2"/>
                    )}
                    Opslaan
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
EditSegmentModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    segment: PropTypes.object,
    onSaved: PropTypes.func,
}

export default React.memo(EditSegmentModal);
